import { useIsCollectionView } from './useCanEditIssues.tsx';
import { useCanEditFields, type CanEditFieldsProps } from './useCanEditFields.tsx';

export const useCanCreateFields = (options?: CanEditFieldsProps): boolean => {
	const canEditFields = useCanEditFields(options);
	const [isCollectionView] = useIsCollectionView();
	return canEditFields && !isCollectionView;
};
